function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M30 6.5v1A1.5 1.5 0 0128.5 9h-27A1.5 1.5 0 010 7.5v-1A1.5 1.5 0 011.5 5h27A1.5 1.5 0 0130 6.5zM23.5 14h-17A1.5 1.5 0 005 15.5v1A1.5 1.5 0 006.5 18h17a1.5 1.5 0 001.5-1.5v-1a1.5 1.5 0 00-1.5-1.5zm-4 9h-9A1.5 1.5 0 009 24.5v1a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5v-1a1.5 1.5 0 00-1.5-1.5z"
})));